import React from 'react';
import { Table } from 'react-bootstrap';
import { HttpHeader } from '../SandBox.types';
import _ from 'lodash';

interface HeaderTableProps {
  headers?: HttpHeader[];
}

const HeaderTable = ({ headers }: HeaderTableProps) => {
  const getItems = () => {
    return _.map(headers, header => {
      return (
        <tr>
          <td>{header.name}</td>
          <td>{header.value}</td>
        </tr>
      );
    });
  };

  if (!headers || headers.length === 0) {
    return <span>No Headers Available</span>;
  }

  return (
    <Table>
      <thead>
        <tr>
          <th>Header Name</th>
          <th>Header Value</th>
        </tr>
      </thead>
      <tbody>{getItems()}</tbody>
    </Table>
  );
};

export default HeaderTable;
